import { render, staticRenderFns } from "./jchg_details.vue?vue&type=template&id=1bf6e694&scoped=true&"
import script from "./jchg_details.vue?vue&type=script&lang=js&"
export * from "./jchg_details.vue?vue&type=script&lang=js&"
import style0 from "./jchg_details.vue?vue&type=style&index=0&id=1bf6e694&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf6e694",
  null
  
)

export default component.exports